module.exports = __webpack_public_path__ + "static/img/14003007.0f73318b.png";